var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"picture",attrs:{"alt":"","src":_vm.getUrl(_vm.media)},on:{"load":_vm.successLoad,"error":_vm.error}})}
var staticRenderFns = []

export { render, staticRenderFns }